import { createContext } from 'react'

export interface OneOnOnesContextValue {
  canSeeOneOnOnes: boolean
  loading: boolean
}

export const OneOnOnesContext = createContext<OneOnOnesContextValue>({
  canSeeOneOnOnes: false,
  loading: true,
})
